import React from "react";

const MapSection = () => {
  return (
    <section className="map-section">
      <div className="container">

        {/* HEADING */}
        <div className="text-center mb-5">
          <h6 className="section-subtitle">OUR LOCATIONS</h6>
          <h2 className="section-title">
            Reach <span>Goodweel Crop Care</span>
          </h2>
          <p className="section-desc">
            Our offices and manufacturing facilities are strategically located
            to support farmers and partners across India with timely service.
          </p>
        </div>

        <div className="row align-items-center">

          {/* LEFT CONTENT */}
          <div className="col-lg-5 mb-4 mb-lg-0">
            <div className="map-info-card">
              <h4>Goodweel Crop Care</h4>

              <div className="map-info">
                <strong>Head Office & Factory</strong>
                <p>
                  Rajkot, Gujarat – 360024, India
                </p>
              </div>

              <div className="map-info">
                <strong>Branch Office</strong>
                <p>
                  Ratlam, Madhya Pradesh – 457001, India
                </p>
              </div>

              <a href="/contact" className="map-btn">
                Get Directions
              </a>
            </div>
          </div>

          {/* RIGHT MAP */}
          <div className="col-lg-7">
            <div className="map-box">
              {/* 🔁 YAHAN AAP GOOGLE MAP EMBED LINK DAAL DENA */}
              <iframe
                title="Goodweel Crop Care Location"
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2828.394822236862!2d75.02640347532372!3d23.349068178946208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjPCsDIwJzU2LjciTiA3NcKwMDEnNDQuMyJF!5e1!3m2!1sen!2sin!4v1770724414361!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default MapSection;
